import * as React from "react";
import { cn } from "./cn";

export const Badge = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement> & {
    variant?: "default" | "secondary" | "success" | "warning" | "destructive";
  }
>(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "bg-primary text-primary-foreground",
    secondary: "bg-muted text-muted-foreground",
    success: "bg-[color-mix(in_srgb,hsl(var(--success))_15%,transparent)] text-success",
    warning: "bg-[color-mix(in_srgb,hsl(var(--warning))_15%,transparent)] text-[hsl(var(--warning))]",
    destructive: "bg-[color-mix(in_srgb,hsl(var(--destructive))_15%,transparent)] text-destructive",
  };
  return (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium transition-colors duration-micro",
        variants[variant],
        className,
      )}
      {...props}
    />
  );
});
Badge.displayName = "Badge";
